import { t } from "i18next";
import { TCountry, TCurrencies, TIdentityType } from "../types/types";
export const currencies: TCurrencies[] = [
  { id: 938, title: "sudanesePound" },
  { id: 840, title: "dollar" },
  { id: 978, title: "Euro" },
  { id: 682, title: "SaudiRial" },
  { id: 784, title: "UaeDirham" },
];

export const steps = [
  { step: 0, title: "/", completed: false },
  { step: 1, title: "/terms", completed: false },
  { step: 2, title: "/personal-info", completed: false },
  { step: 3, title: "/email-verifcation", completed: false },
  { step: 4, title: "/otp", completed: false },
  { step: 5, title: "/identity-verification", completed: false },
  { step: 6, title: "/identity", completed: false },
  { step: 7, title: "/scan", completed: false },
  { step: 8, title: "/display-personal-info", completed: false },
  { step: 9, title: "/signeture", completed: false },
  { step: 10, title: "/done", completed: false },
];

export const identityTypes: TIdentityType[] = [
  { id: 1, title: "passport" },
  { id: 2, title: "nationalId" },
];

export const notes = [
  { id: 1, title: "note1" },
  { id: 2, title: "note2" },
  { id: 3, title: "note3" },
  { id: 4, title: "note4" },
  { id: 5, title: "note5" }
];

export const gender = [
  { id: "M", title: "male" },
  { id: "F", title: "female" },
];

export const countryCodes = [
  { code: "+244", label: "angola" },
  { code: "+1-268", label: "antigua and barbuda" },
  { code: "+994", label: "azerbaijan" },
  { code: "+54", label: "argentina" },
  { code: "+61", label: "australia" },
  { code: "+43", label: "austria" },
  { code: "+1-242", label: "bahamas" },
  { code: "+973", label: "bahrain" },
  { code: "+880", label: "bangladesh" },
  { code: "+374", label: "armenia" },
  { code: "+1-246", label: "barbados" },
  { code: "+32", label: "belgium" },
  { code: "+1-441", label: "bermuda" },
  { code: "+975", label: "bhutan" },
  { code: "+591", label: "bolivia" },
  { code: "+387", label: "bosnia and herzegowina" },
  { code: "+267", label: "botswana" },
  { code: "+47", label: "bouvet island" },
  { code: "+55", label: "brazil" },
  { code: "+501", label: "belize" },
  { code: "+246", label: "british indian ocean territory" },
  { code: "+677", label: "solomon islands" },
  { code: "+1-284", label: "virgin islands (british)" },
  { code: "+673", label: "brunei darussalam" },
  { code: "+359", label: "bulgaria" },
  { code: "+95", label: "myanmar" },
  { code: "+257", label: "burundi" },
  { code: "+375", label: "belarus" },
  { code: "+855", label: "cambodia" },
  { code: "+237", label: "cameroon" },
  { code: "+1", label: "canada" },
  { code: "+238", label: "cape verde" },
  { code: "+1-345", label: "cayman islands" },
  { code: "+236", label: "central african republic" },
  { code: "+94", label: "sri lanka" },
  { code: "+235", label: "chad" },
  { code: "+56", label: "chile" },
  { code: "+86", label: "china" },
  { code: "+886", label: "taiwan" },
  { code: "+61", label: "christmas island" },
  { code: "+61", label: "cocos (keeling) islands" },
  { code: "+57", label: "colombia" },
  { code: "+269", label: "comoros" },
  { code: "+262", label: "mayotte" },
  { code: "+243", label: "congo (drc)" },
  { code: "+242", label: "congo (republic)" },
  { code: "+682", label: "cook islands" },
  { code: "+506", label: "costa rica" },
  { code: "+385", label: "croatia (local name: hrvatska)" },
  { code: "+53", label: "cuba" },
  { code: "+357", label: "cyprus" },
  { code: "+420", label: "czech republic" },
  { code: "+229", label: "benin" },
  { code: "+45", label: "denmark" },
  { code: "+1-767", label: "dominica" },
  { code: "+1-809", label: "dominican republic" },
  { code: "+593", label: "ecuador" },
  { code: "+503", label: "el salvador" },
  { code: "+240", label: "equatorial guinea" },
  { code: "+251", label: "ethiopia" },
  { code: "+291", label: "eritrea" },
  { code: "+372", label: "estonia" },
  { code: "+298", label: "faroe islands" },
  { code: "+500", label: "falkland islands (malvinas)" },
  { code: "+500", label: "south georgia & south sandwich islands" },
  { code: "+679", label: "fiji" },
  { code: "+358", label: "finland" },
  { code: "+358", label: "aland island" },
  { code: "+33", label: "france" },
  { code: "+594", label: "french guiana" },
  { code: "+689", label: "french polynesia" },
  { code: "+262", label: "french southern territories" },
  { code: "+253", label: "djibouti" },
  { code: "+241", label: "gabon" },
  { code: "+995", label: "georgia" },
  { code: "+220", label: "gambia" },
  { code: "+970", label: "palestinian territory, occupied" },
  { code: "+49", label: "germany" },
  { code: "+233", label: "ghana" },
  { code: "+350", label: "gibraltar" },
  { code: "+686", label: "kiribati" },
  { code: "+30", label: "greece" },
  { code: "+299", label: "greenland" },
  { code: "+1-473", label: "grenada" },
  { code: "+590", label: "guadeloupe" },
  { code: "+1-671", label: "guam" },
  { code: "+502", label: "guatemala" },
  { code: "+224", label: "guinea" },
  { code: "+592", label: "guyana" },
  { code: "+509", label: "haiti" },
  { code: "+672", label: "heard and mc donald islands" },
  { code: "+379", label: "vatican city state (holy see)" },
  { code: "+504", label: "honduras" },
  { code: "+852", label: "hong kong" },
  { code: "+36", label: "hungary" },
  { code: "+354", label: "iceland" },
  { code: "+91", label: "india" },
  { code: "+62", label: "indonesia" },
  { code: "+98", label: "iran (islamic republic of)" },
  { code: "+964", label: "iraq" },
  { code: "+353", label: "ireland" },
  { code: "+39", label: "italy" },
  { code: "+225", label: "cote d'ivoire" },
  { code: "+1-876", label: "jamaica" },
  { code: "+81", label: "japan" },
  { code: "+7", label: "kazakhstan" },
  { code: "+962", label: "jordan" },
  { code: "+254", label: "kenya" },
  { code: "+850", label: "korea, democratic people's republic of" },
  { code: "+82", label: "korea, republic of" },
  { code: "+965", label: "kuwait" },
  { code: "+996", label: "kyrgyzstan" },
  { code: "+856", label: "laos people's democratic republic" },
  { code: "+961", label: "lebanon" },
  { code: "+266", label: "lesotho" },
  { code: "+371", label: "latvia" },
  { code: "+231", label: "liberia" },
  { code: "+218", label: "libyan arab jamahiriya" },
  { code: "+423", label: "liechtenstein" },
  { code: "+370", label: "lithuania" },
  { code: "+352", label: "luxembourg" },
  { code: "+853", label: "macao" },
  { code: "+261", label: "madagascar" },
  { code: "+265", label: "malawi" },
  { code: "+60", label: "malaysia" },
  { code: "+960", label: "maldives" },
  { code: "+223", label: "mali" },
  { code: "+356", label: "malta" },
  { code: "+596", label: "martinique" },
  { code: "+222", label: "mauritania" },
  { code: "+230", label: "mauritius" },
  { code: "+52", label: "mexico" },
  { code: "+377", label: "monaco" },
  { code: "+976", label: "mongolia" },
  { code: "+373", label: "moldova, republic of" },
  { code: "+1-664", label: "montserrat" },
  { code: "+212", label: "morocco" },
  { code: "+258", label: "mozambique" },
  { code: "+968", label: "oman" },
  { code: "+264", label: "namibia" },
  { code: "+674", label: "nauru" },
  { code: "+977", label: "nepal" },
  { code: "+31", label: "netherlands" },
  { code: "+599", label: "netherlands antilles" },
  { code: "+687", label: "new caledonia" },
  { code: "+64", label: "new zealand" },
  { code: "+505", label: "nicaragua" },
  { code: "+227", label: "niger" },
  { code: "+234", label: "nigeria" },
  { code: "+683", label: "niue" },
  { code: "+672", label: "norfolk island" },
  { code: "+47", label: "norway" },
  { code: "+1-670", label: "northern mariana islands" },
  { code: "+680", label: "palau" },
  { code: "+507", label: "panama" },
  { code: "+675", label: "papua new guinea" },
  { code: "+595", label: "paraguay" },
  { code: "+51", label: "peru" },
  { code: "+63", label: "philippines" },
  { code: "+870", label: "pitcairn" },
  { code: "+48", label: "poland" },
  { code: "+351", label: "portugal" },
  { code: "+1-787", label: "puerto rico" },
  { code: "+974", label: "qatar" },
  { code: "+262", label: "reunion" },
  { code: "+40", label: "romania" },
  { code: "+7", label: "russian federation" },
  { code: "+250", label: "rwanda" },
  { code: "+290", label: "st. helena" },
  { code: "+1-869", label: "saint kitts and nevis" },
  { code: "+1-758", label: "saint lucia" },
  { code: "+508", label: "st. pierre and miquelon" },
  { code: "+1-784", label: "saint vincent and the grenadines" },
  { code: "+378", label: "san marino" },
  { code: "+239", label: "sao tome and principe" },
  { code: "+966", label: "saudi arabia" },
  { code: "+221", label: "senegal" },
  { code: "+248", label: "seychelles" },
  { code: "+232", label: "sierra leone" },
  { code: "+65", label: "singapore" },
  { code: "+421", label: "slovakia (slovak republic)" },
  { code: "+386", label: "slovenia" },
  { code: "+252", label: "somalia" },
  { code: "+27", label: "south africa" },
  { code: "+263", label: "zimbabwe" },
  { code: "+34", label: "spain" },
  { code: "+211", label: "south sudan" },
  { code: "+249", label: "sudan" },
  { code: "+597", label: "suriname" },
  { code: "+47", label: "svalbard and jan mayen" },
  { code: "+268", label: "swaziland" },
  { code: "+46", label: "sweden" },
  { code: "+41", label: "switzerland" },
  { code: "+963", label: "syrian arab republic" },
  { code: "+992", label: "tajikistan" },
  { code: "+66", label: "thailand" },
  { code: "+228", label: "togo" },
  { code: "+690", label: "tokelau" },
  { code: "+676", label: "tonga" },
  { code: "+1-868", label: "trinidad and tobago" },
  { code: "+971", label: "united arab emirates" },
  { code: "+216", label: "tunisia" },
  { code: "+90", label: "turkey" },
  { code: "+993", label: "turkmenistan" },
  { code: "+1-649", label: "turks and caicos islands" },
  { code: "+688", label: "tuvalu" },
  { code: "+256", label: "uganda" },
  { code: "+380", label: "ukraine" },
  { code: "+389", label: "macedonia" },
  { code: "+20", label: "egypt" },
  { code: "+44", label: "united kingdom" },
  { code: "+44", label: "jersey" },
  { code: "+255", label: "tanzania, united republic" },
  { code: "+1", label: "united states" },
  { code: "+1-340", label: "virgin islands (u.s.)" },
  { code: "+226", label: "burkina faso" },
  { code: "+598", label: "uruguay" },
  { code: "+998", label: "uzbekistan" },
  { code: "+58", label: "venezuela" },
  { code: "+681", label: "wallis and futuna islands" },
  { code: "+685", label: "samoa" },
  { code: "+967", label: "yemen" },
  { code: "+381", label: "serbia and montenegro" },
  { code: "+260", label: "zambia" },
];

export const countries: TCountry[] = [
  { id: 24, title: "angola", code: "AO" },
  { id: 28, title: "antigua and barbuda", code: "AG" },
  { id: 31, title: "azerbaijan", code: "AZ" },
  { id: 32, title: "argentina", code: "AR" },
  { id: 36, title: "australia", code: "AU" },
  { id: 40, title: "austria", code: "AT" },
  { id: 44, title: "bahamas", code: "BS" },
  { id: 48, title: "bahrain", code: "BH" },
  { id: 50, title: "bangladesh", code: "BD" },
  { id: 51, title: "armenia", code: "AM" },
  { id: 52, title: "barbados", code: "BB" },
  { id: 56, title: "belgium", code: "BE" },
  { id: 60, title: "bermuda", code: "BM" },
  { id: 64, title: "bhutan", code: "BT" },
  { id: 68, title: "bolivia", code: "BO" },
  { id: 70, title: "bosnia and herzegowina", code: "BA" },
  { id: 72, title: "botswana", code: "BW" },
  { id: 74, title: "bouvet island", code: "BV" },
  { id: 76, title: "brazil", code: "BR" },
  { id: 84, title: "belize", code: "BZ" },
  { id: 86, title: "british indian ocean territory", code: "IO" },
  { id: 90, title: "solomon islands", code: "SB" },
  { id: 92, title: "virgin islands (british)", code: "VG" },
  { id: 96, title: "brunei darussalam", code: "BN" },
  { id: 100, title: "bulgaria", code: "BG" },
  { id: 104, title: "myanmar", code: "MM" },
  { id: 108, title: "burundi", code: "BI" },
  { id: 112, title: "belarus", code: "BY" },
  { id: 116, title: "cambodia", code: "KH" },
  { id: 120, title: "cameroon", code: "CM" },
  { id: 124, title: "canada", code: "CA" },
  { id: 132, title: "cape verde", code: "CV" },
  { id: 136, title: "cayman islands", code: "KY" },
  { id: 140, title: "central african republic", code: "CF" },
  { id: 144, title: "sri lanka", code: "LK" },
  { id: 148, title: "chad", code: "TD" },
  { id: 152, title: "chile", code: "CL" },
  { id: 156, title: "china", code: "CN" },
  { id: 158, title: "taiwan", code: "TW" },
  { id: 162, title: "christmas island", code: "CX" },
  { id: 166, title: "cocos (keeling) islands", code: "CC" },
  { id: 170, title: "colombia", code: "CO" },
  { id: 174, title: "comoros", code: "KM" },
  { id: 175, title: "mayotte", code: "YT" },
  { id: 178, title: "congo (drc)", code: "CG" },
  { id: 180, title: "congo (republic)", code: "CD" },
  { id: 184, title: "cook islands", code: "CK" },
  { id: 188, title: "costa rica", code: "CR" },
  { id: 191, title: "croatia (local name: hrvatska)", code: "HR" },
  { id: 192, title: "cuba", code: "CU" },
  { id: 196, title: "cyprus", code: "CY" },
  { id: 203, title: "czech republic", code: "CZ" },
  { id: 204, title: "benin", code: "BJ" },
  { id: 208, title: "denmark", code: "DK" },
  { id: 212, title: "dominica", code: "DM" },
  { id: 214, title: "dominican republic", code: "DO" },
  { id: 218, title: "ecuador", code: "EC" },
  { id: 222, title: "el salvador", code: "SV" },
  { id: 226, title: "equatorial guinea", code: "GQ" },
  { id: 231, title: "ethiopia", code: "ET" },
  { id: 232, title: "eritrea", code: "ER" },
  { id: 233, title: "estonia", code: "EE" },
  { id: 234, title: "faroe islands", code: "FO" },
  { id: 238, title: "falkland islands (malvinas)", code: "FK" },
  { id: 239, title: "south georgia & south sandwich islands", code: "GS" },
  { id: 242, title: "fiji", code: "FJ" },
  { id: 246, title: "finland", code: "FI" },
  { id: 248, title: "aland island", code: "AX" },
  { id: 250, title: "france", code: "FR" },
  { id: 254, title: "french guiana", code: "GF" },
  { id: 258, title: "french polynesia", code: "PF" },
  { id: 260, title: "french southern territories", code: "TF" },
  { id: 262, title: "djibouti", code: "DJ" },
  { id: 266, title: "gabon", code: "GA" },
  { id: 268, title: "georgia", code: "GE" },
  { id: 270, title: "gambia", code: "GM" },
  { id: 275, title: "palestinian territory, occupied", code: "PS" },
  { id: 276, title: "germany", code: "DE" },
  { id: 288, title: "ghana", code: "GH" },
  { id: 292, title: "gibraltar", code: "GI" },
  { id: 296, title: "kiribati", code: "KI" },
  { id: 300, title: "greece", code: "GR" },
  { id: 304, title: "greenland", code: "GL" },
  { id: 308, title: "grenada", code: "GD" },
  { id: 312, title: "guadeloupe", code: "GP" },
  { id: 316, title: "guam", code: "GU" },
  { id: 320, title: "guatemala", code: "GT" },
  { id: 324, title: "guinea", code: "GN" },
  { id: 328, title: "guyana", code: "GY" },
  { id: 332, title: "haiti", code: "HT" },
  { id: 334, title: "heard and mc donald islands", code: "HM" },
  { id: 336, title: "vatican city state (holy see)", code: "VA" },
  { id: 340, title: "honduras", code: "HN" },
  { id: 344, title: "hong kong", code: "HK" },
  { id: 348, title: "hungary", code: "HU" },
  { id: 352, title: "iceland", code: "IS" },
  { id: 356, title: "india", code: "IN" },
  { id: 360, title: "indonesia", code: "ID" },
  { id: 364, title: "iran (islamic republic of)", code: "IR" },
  { id: 368, title: "iraq", code: "IQ" },
  { id: 372, title: "ireland", code: "IE" },
  { id: 380, title: "italy", code: "IT" },
  { id: 384, title: "cote d'ivoire", code: "CI" },
  { id: 388, title: "jamaica", code: "JM" },
  { id: 392, title: "japan", code: "JP" },
  { id: 398, title: "kazakhstan", code: "KZ" },
  { id: 400, title: "jordan", code: "JO" },
  { id: 404, title: "kenya", code: "KE" },
  { id: 408, title: "korea, democratic people's republic of", code: "KP" },
  { id: 410, title: "korea, republic of", code: "KR" },
  { id: 414, title: "kuwait", code: "KW" },
  { id: 417, title: "kyrgyzstan", code: "KG" },
  { id: 418, title: "laos people's democratic republic", code: "LA" },
  { id: 422, title: "lebanon", code: "LB" },
  { id: 426, title: "lesotho", code: "LS" },
  { id: 428, title: "latvia", code: "LV" },
  { id: 430, title: "liberia", code: "LR" },
  { id: 434, title: "libyan arab jamahiriya", code: "LY" },
  { id: 438, title: "liechtenstein", code: "LI" },
  { id: 440, title: "lithuania", code: "LT" },
  { id: 442, title: "luxembourg", code: "LU" },
  { id: 446, title: "macao", code: "MO" },
  { id: 450, title: "madagascar", code: "MG" },
  { id: 454, title: "malawi", code: "MW" },
  { id: 458, title: "malaysia", code: "MY" },
  { id: 462, title: "maldives", code: "MV" },
  { id: 466, title: "mali", code: "ML" },
  { id: 470, title: "malta", code: "MT" },
  { id: 474, title: "martinique", code: "MQ" },
  { id: 478, title: "mauritania", code: "MR" },
  { id: 480, title: "mauritius", code: "MU" },
  { id: 484, title: "mexico", code: "MX" },
  { id: 492, title: "monaco", code: "MC" },
  { id: 496, title: "mongolia", code: "MN" },
  { id: 498, title: "moldova, republic of", code: "MD" },
  { id: 500, title: "montserrat", code: "MS" },
  { id: 504, title: "morocco", code: "MA" },
  { id: 508, title: "mozambique", code: "MZ" },
  { id: 512, title: "oman", code: "OM" },
  { id: 516, title: "namibia", code: "NA" },
  { id: 520, title: "nauru", code: "NR" },
  { id: 524, title: "nepal", code: "NP" },
  { id: 528, title: "netherlands", code: "NL" },
  { id: 533, title: "aruba", code: "AW" },
  { id: 540, title: "new caledonia", code: "NC" },
  { id: 548, title: "vanuatu", code: "VU" },
  { id: 554, title: "new zealand", code: "NZ" },
  { id: 558, title: "nicaragua", code: "NI" },
  { id: 562, title: "niger", code: "NE" },
  { id: 566, title: "nigeria", code: "NG" },
  { id: 570, title: "niue", code: "NU" },
  { id: 574, title: "norfolk island", code: "NF" },
  { id: 578, title: "norway", code: "NO" },
  { id: 580, title: "northern mariana islands", code: "MP" },
  { id: 583, title: "micronesia, federated states", code: "FM" },
  { id: 584, title: "marshall islands", code: "MH" },
  { id: 585, title: "palau", code: "PW" },
  { id: 586, title: "pakistan", code: "PK" },
  { id: 591, title: "panama", code: "PA" },
  { id: 598, title: "papua new guinea", code: "PG" },
  { id: 600, title: "paraguay", code: "PY" },
  { id: 604, title: "peru", code: "PE" },
  { id: 608, title: "philippines", code: "PH" },
  { id: 612, title: "pitcairn", code: "PN" },
  { id: 616, title: "poland", code: "PL" },
  { id: 620, title: "portugal", code: "PT" },
  { id: 624, title: "guinea-bissau", code: "GW" },
  { id: 626, title: "east timor", code: "TL" },
  { id: 630, title: "puerto rico", code: "PR" },
  { id: 634, title: "qatar", code: "QA" },
  { id: 638, title: "reunion", code: "RE" },
  { id: 642, title: "romania", code: "RO" },
  { id: 643, title: "russian federation", code: "RU" },
  { id: 646, title: "rwanda", code: "RW" },
  { id: 654, title: "st. helena", code: "SH" },
  { id: 659, title: "saint kitts and nevis", code: "KN" },
  { id: 660, title: "anguilla", code: "AI" },
  { id: 662, title: "saint lucia", code: "LC" },
  { id: 666, title: "st. pierre and miquelon", code: "PM" },
  { id: 670, title: "saint vincent and the grenadines", code: "VC" },
  { id: 674, title: "san marino", code: "SM" },
  { id: 678, title: "sao tome and principe", code: "ST" },
  { id: 682, title: "saudi arabia", code: "SA" },
  { id: 686, title: "senegal", code: "SN" },
  { id: 690, title: "seychelles", code: "SC" },
  { id: 694, title: "sierra leone", code: "SL" },
  { id: 702, title: "singapore", code: "SG" },
  { id: 703, title: "slovakia (slovak republic)", code: "SK" },
  { id: 704, title: "viet nam", code: "VN" },
  { id: 705, title: "slovenia", code: "SI" },
  { id: 706, title: "somalia", code: "SO" },
  { id: 710, title: "south africa", code: "ZA" },
  { id: 716, title: "zimbabwe", code: "ZW" },
  { id: 724, title: "spain", code: "ES" },
  { id: 728, title: "south sudan", code: "SS" },
  { id: 729, title: "sudan", code: "SD" },
  { id: 740, title: "suriname", code: "SR" },
  { id: 744, title: "svalbard and jan mayen", code: "SJ" },
  { id: 748, title: "swaziland", code: "SZ" },
  { id: 752, title: "sweden", code: "SE" },
  { id: 756, title: "switzerland", code: "CH" },
  { id: 760, title: "syrian arab republic", code: "SY" },
  { id: 762, title: "tajikistan", code: "TJ" },
  { id: 764, title: "thailand", code: "TH" },
  { id: 768, title: "togo", code: "TG" },
  { id: 772, title: "tokelau", code: "TK" },
  { id: 776, title: "tonga", code: "TO" },
  { id: 780, title: "trinidad and tobago", code: "TT" },
  { id: 784, title: "united arab emirates", code: "AE" },
  { id: 788, title: "tunisia", code: "TN" },
  { id: 792, title: "turkey", code: "TR" },
  { id: 795, title: "turkmenistan", code: "TM" },
  { id: 796, title: "turks and caicos islands", code: "TC" },
  { id: 798, title: "tuvalu", code: "TV" },
  { id: 800, title: "uganda", code: "UG" },
  { id: 804, title: "ukraine", code: "UA" },
  { id: 807, title: "macedonia", code: "MK" },
  { id: 818, title: "egypt", code: "EG" },
  { id: 826, title: "united kingdom", code: "GB" },
  { id: 832, title: "jersey", code: "JE" },
  { id: 834, title: "tanzania, united republic", code: "TZ" },
  { id: 840, title: "united states", code: "US" },
  { id: 850, title: "virgin islands (u.s.)", code: "VI" },
  { id: 854, title: "burkina faso", code: "BF" },
  { id: 858, title: "uruguay", code: "UY" },
  { id: 860, title: "uzbekistan", code: "UZ" },
  { id: 862, title: "venezuela", code: "VE" },
  { id: 876, title: "wallis and futuna islands", code: "WF" },
  { id: 882, title: "samoa", code: "WS" },
  { id: 887, title: "yemen", code: "YE" },
  { id: 891, title: "serbia and montenegro", code: "RS" },
  { id: 894, title: "zambia", code: "ZM" },
];
